import React, { useEffect, useState } from 'react';
import { nowIst } from '../lib/format';
import { Clock } from 'lucide-react';

/** Live IST clock badge — the official CRM time (Asia/Kolkata, UTC+5:30). */
export const ISTClock = ({ compact = false }) => {
  const [now, setNow] = useState(() => nowIst());

  useEffect(() => {
    const t = setInterval(() => setNow(nowIst()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="ist-clock-badge"
      title="Official CRM time — Indian Standard Time (UTC+5:30)"
      className={`inline-flex items-center gap-1.5 rounded-lg border border-primary/20 bg-primary/5 text-primary font-medium tabular-nums select-none ${
        compact ? 'px-2 h-8 text-[11px]' : 'px-2.5 h-9 text-xs'
      }`}
    >
      <Clock size={compact ? 12 : 13} className="shrink-0" />
      {!compact && <span className="text-muted-foreground font-normal hidden xl:inline">{now.format('ddd, DD MMM')}</span>}
      <span data-testid="ist-clock-time">{now.format('hh:mm:ss A')}</span>
      <span className="text-[10px] font-semibold text-primary/70">IST</span>
    </div>
  );
};
